import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalFormManuallyAddAccount } from "../components/ModalFormManuallyAddAccount";

export const useModalFormManuallyAddAccount = () =>
  useWSModal(ModalFormManuallyAddAccount, {
    title: "Where should we pay you?",
    size: "S"
  });
